module.exports = __webpack_public_path__ + "img/v1-8.01f1c87f.png";